import { DEFAULT_ACTION_SOURCE } from '../utils/constants';
import { closeDeeplinkReadingPane } from 'owa-mail-actions/lib/readingPaneActions';
import { lazyResetFocus } from 'owa-mail-focus-manager';
import { getSelectedTableView } from 'owa-mail-list-store';
import { ClientItem } from 'owa-mail-store';
import { lazyMarkItemAsPhishingFromReadingPane } from 'owa-mail-triage-action';
import * as React from 'react';

export default function onPhishing(item: ClientItem) {
    return (event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();

        lazyMarkItemAsPhishingFromReadingPane
            .importAndExecute(item.ItemId.Id, getSelectedTableView(), DEFAULT_ACTION_SOURCE)
            .then(() => {
                closeDeeplinkReadingPane();
            });
        lazyResetFocus.importAndExecute();
    };
}
